import React, { useState, useEffect, useRef } from 'react'
import TextField from './../component/TextField'
import service from '../services';
import SimpleReactValidator from 'simple-react-validator';
import { useSelector } from 'react-redux';

let sub;

const SearchUserModal = (props) => {
    const { CloseModal } = props
    const MY_ROLE = useSelector(state => state.getLoginRole.user.role);
    const [email, setemail] = useState('');
    const validator = useRef(new SimpleReactValidator())
    const apiserve = new service();
    const [userList, setUserList] = useState([])
    const [EmptyError, setEmptyError] = useState('')
    const [Loading, setLoading] = useState(false)
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const LOADER = "data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="


    useEffect(() => {
        sub = apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "admin|getUserByEmail":
                    setLoading(false)
                    if (!response.error) setUserList(response.data)
                    else {
                        setEmptyError(response.data.error)
                        setUserList([])
                    }
                    break;
                default:
                    break;
            }
        })

        return () => {
            if (sub) sub.unsubscribe();
        }

    }, []);

    // Search Email For Availibility...
    const searchEmail = (e) => {
        e.preventDefault();
        if (validateEmail()) {
            setLoading(true)
            apiserve.sendevent("admin|getUserByEmail", { email: email });
        }
    };

    // For Validate Entered Email
    const validateEmail = () => {
        if (validator.current.allValid()) return true;
        else {
            validator.current.showMessages();
            forceUpdate();
        }
    };

    // Check For Button Is Disable OR Not
    const isDisabled = (GET_USER_ROLE) => {
        // if (getRole(MY_ROLE) === GET_USER_ROLE || GET_USER_ROLE === 'General') return false;
        // else 
        return true;
    };

    const getuserRole = (roles) => {
        const roleMap = {
            circleGuestUser: 'Sundance Guest',
            sioUser: 'Industry',
            pressUser: 'Press',
            circleUser: 'Sundance Circle',
            artistUser: 'Artist',
            generalUser: 'General',
            pafUser: 'PAF',
        };
        if (roles.length > 1) {
            const lastRole = roleMap[roles[roles.length - 1]] || '';
            const otherRoles = roles.slice(0, -1).map(role => roleMap[role] || '').filter(Boolean);
            return otherRoles.length ? `${otherRoles.join(', ')} & ${lastRole}` : lastRole;
        } else if (roles.length === 1) {
            return roleMap[roles[0]] || '';
        }
    }

    // For Display Available User List...
    const getUserList = () => {
        if (Object.keys(userList).length > 0) {
            if (userList.additionalRoles.length === 0 || !userList.additionalRoles.includes('admin')) {
                return (
                    <>
                        <div className="disp_flex table_content">
                            <div className="table_wrap mr_10">
                                <table>
                                    <tr>
                                        <th style={{ width: "192px" }}>Email</th>
                                        <th style={{ width: "100px" }}>First Name</th>
                                        <th style={{ width: "100px" }}>Last Name</th>
                                        <th style={{ width: "100px" }}>Role</th>
                                        <th></th>
                                    </tr>
                                    <tr>
                                        <td>{userList.email}</td>
                                        <td>{userList.fname}</td>
                                        <td>{userList.lname}</td>
                                        <td>{getuserRole(userList.additionalRoles)}</td>
                                        <td><div className="field_row mb_0"> <button className="uppercase" onClick={() => props.SelectUser(userList._id)} >select</button> </div></td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                    </>
                )
            }
            else if (userList.additionalRoles.includes('admin')) {
                return (
                    <div className="disp_flex table_content">
                        <div className="table_wrap mr_10">
                            <table>
                                <tr>
                                    <th style={{ width: "192px" }}>Email</th>
                                    <th style={{ width: "100px" }}>First Name</th>
                                    <th style={{ width: "100px" }}>Last Name</th>
                                    <th style={{ width: "100px" }}>Role</th>
                                    <th></th>
                                </tr>
                                <tr>
                                    <td>{userList.email}</td>
                                    <td>{userList.fname}</td>
                                    <td>{userList.lname}</td>
                                    <td>{getuserRole(userList.additionalRoles)}</td>
                                    <td><div className="field_row mb_0"> <button className="uppercase" onClick={() => props.SelectUser(userList._id)} disabled >select</button> </div></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                )
            }
            else {
                return (<div className="no_found text_center table_content"> <h5 style={{ color: 'green' }}>
                    This user has already been created as an Adminstration role.
                    {/* {getRole(userList.role)} */}
                </h5> </div>)
            }
        }
        else {
            return (
                <div className="no_found text_center table_content">
                    {
                        EmptyError && <>
                            <h5>No user found.</h5>
                            <h5>You may create a new user with that email.</h5>
                            <div className="field_row"> <button className="uppercase" onClick={createNewUser}>CREATE USER</button> </div>
                        </>
                    }
                </div>
            )
        }
    };

    // Get Role Name Of User...
    const getRole = (ROLE) => {
        switch (ROLE) {
            case 'sio':
                return 'Industry'
            case 'press':
                return 'Press'
            case 'general':
                return 'General'
            case 'sundanceGuest':
                return 'Guest'
            case 'artist':
                return 'Artist'
            default:
                break;
        }
    };

    const getUserRole = (ROLE) => {
        switch (ROLE) {
            case 'sioUser':
                return 'IndustryUser'
            case 'pressUser':
                return 'PressUser'
            case 'circleGuestUser':
                return 'GuestUser'
            case 'generalUser':
                return 'GeneralUser'
            case 'artistUser':
                return 'ArtistUser'
            default:
                break;
        }
    };



    // For Create New User
    const createNewUser = () => { if (validateEmail()) props.CreateNewUser(email); };

    return (
        <div className="user_popup active">
            <span className="popup_overlay" onClick={CloseModal}></span>
            <div className="sundance_popup_createuser box_shadow">
                <span className="closePopup pointer" onClick={CloseModal}>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9.899 0L5.656 4.242L1.414 0L0 1.414L4.242 5.656L0 9.898L1.414 11.312L5.656 7.07L9.899 11.312L11.313 9.898L7.071 5.656L11.313 1.414L9.899 0Z" fill="black" /> </svg>
                </span>
                <div className="bg_white">
                    <div className="sundance_popup_createuser_top">
                        <div className="selection_pass text_center">
                            <label className="pass_label mb_10">Search User</label>
                            <label className="field_label">Look up by user email</label>
                        </div>
                        <form onSubmit={searchEmail}>
                            <div className="field_row pb_10">
                                <TextField autoFocus={true} type="text" placeholder="Email" name="email" value={email} onChange={(e) => setemail(e.target.value.trim())} maxLength={255} />
                                <span style={{ color: 'red' }}>{validator.current.message('email', email, 'required|email|max:255')}</span>
                            </div>
                            <div className="field_row text_center">
                                <button className="uppercase active" onClick={searchEmail}>Search <img src={Loading && LOADER}></img></button>
                            </div>
                        </form>
                    </div>
                    {getUserList()}
                </div>
            </div>
        </div>
    )
}
export default SearchUserModal